import { msMinutes } from "../../utilities/msMinutes";
import { nextDate } from "./nextDate";
import { startTimer } from "./startTimer";
import { countdownCallback } from "./countdownCallback";
const timerStartTimes = new Set();
export function countdownService(service, status) {
    if (!status) {
        return;
    }
    if (!service.ignoreCountdown) {
        const startTime = service.date ||
            nextDate(service.repeat, service.day, service.time, service.period);
        const startTimeStr = startTime.toString();
        if (!timerStartTimes.has(startTimeStr)) {
            // avoid overlapping countdowns for the same time
            startTimer(msMinutes(2), startTime, service.repeat, service, countdownCallback);
            timerStartTimes.add(startTimeStr);
        }
    }
}
